import { Box } from "@radix-ui/themes";
import { JSX } from "react";

interface Children {
  children: JSX.Element | string;
}

function NewsParagraph(props: Children) {
  return (
    <Box
      style={{
        fontFamily: "Courier",
        marginTop: "10px",
        marginBottom: "10px",
        color: "var(--ro-text)", // Bright gold color to match Victorian aesthetic
      }}
    >
      <Box>{props.children as string}</Box>
    </Box>
  );
}

export default NewsParagraph;
